import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_PsConsentToServicesForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_PsConsentToServicesForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>Person Served Consent to Services</h3></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Served</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Record #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServed' name='txtPersonServed' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRecord' name='txtRecord' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>I,&nbsp;<input type='text' id='txtTheUndersigned' name='txtTheUndersigned' className='add-only w-300 custom-add-only' />the undersigned, hereby attest that I have voluntarily entered into treatment, or give my consent for the minor or person under my legal guardianship mentioned above, at Heritage Foundation,
                    Inc. (programs), hereby referred to as HFI. Further,
                    I consent to have services provided by a psychiatrist, psychologist, social worker, counselor, Master/Bachelor Level clinician, support staff, interns under supervision and other organization staff. The rights, risks,
                    and benefits associated with the services have been explained to me.
                </p>
                <p className='w-750'><span className='eleHeader'>Person Served Rights:</span>
                    I certify that I have received the Person Served and certify that I have read and understand its content.
                    I understand that as a recipient of services,
                    I may get more information from the clinical staff.</p>

                <p className='w-750'><span className='eleHeader'>Confidentiality:</span>
                    I certify that I have received the Limits of Confidentiality and certify that I have read and understand its content. I understand services are provide and are considered legally protected as
                    privileged information with exceptions outlined in the Limits of Confidentiality</p>

                <p className='w-750'><span className='eleHeader'>Non-voluntarily Discharge from Services: </span>
                    I understand that the services may be discontinued at any time by either party. HFI encourages that this decision be discussed with the appropriate clinical staff.
                    This will help facilitate a more appropriate plan for discharge.  <br />

                    A Person Served may be terminated from HFI involuntarily. if: (A) the Person served exhibits physical violence, verbal abuse,
                    carries weapons, or engages in illegal acts at the clinic, and/or (B) the person served refuses to comply with stipulated program
                    rules, refuses to comply with services recommendations, or does not make payment or payment arrangements in a timely manner.
                    The person served will be notified of the non-involuntary discharge by letter. The person served may appeal this decision with the Program Manager/Clinical Director/Executive
                    Director or request to reapply for services at a later date.</p>

                <p className='w-750'><span className='eleHeader'>Person Served Notice of Confidentiality: </span>
                    The confidentiality of person served records maintained by HFI is protected by federal and/or state law and regulations.
                    Generally, HFI may not say to a person outside HFI that a person served attends the program or disclose any information
                    identifying a person served as an alcohol or drug abuser unless: (1) the person served consents in writing, (2) the disclosure is
                    allowed by a court order, or (3) the disclosure is made to medical personnel in a medical emergency, or to qualified personnel for
                    research, audit, or program evaluation. Person served data of clinical outcomes may be used for program evaluation purposes,
                    but individual results will not be disclosed to outside sources. <br /> <br />

                    Violation of federal and/or state law and regulations by a treatment facility or service provider is a crime.
                    Suspected violations may be reported to appropriate authorities. Federal and/or state law and regulations do not protect
                    any information about a crime committed by a person served either at HFI, against any person who works for the program, or about
                    any threat to commit such a crime. Federal law and regulations do not protect any information about suspected child (or vulnerable adult) abuse or neglect, or adult abuse from being reported under federal and/or state
                    law to appropriate state or local authorities. Health care professionals are required to report admitted prenatal exposure to controlled substances that are potentially harmful. It is HFI duty to warn any potential victim when a significant threat of harm has been made. In the event of a client's death, the
                    spouse or parents of a deceased person served have a right to access their child's or spouse's records.
                    Professional misconduct by a health care professional must be reported by other health care professionals, in which related person served records may be released to substantiate disciplinary concerns. Parents or legal guardians of non-emancipated minor
                    clients have the right to access the client's records. When fees are not paid in a timely manner,
                    a collection agency will be given appropriate billing and financial information about the client, not clinical information. My signature below indicates that I have been given a copy of my rights regarding confidentiality. I permit a copy of this authorization to be used in place of the original.  <br /> <br />

                    By signing this document, you are indicating your agreement that your participating in services will not include calling staff as a witness in a court proceeding. Be aware that once services are initiated, it is unethical for staff to give any opinion/recommendation about issues in a legal/court setting such as custody/visitation arrangements or other
                    legal issues, even if staff is compelled by a judge to be a witness. Staff are not considered forensic experts in legal matters. If a staff is required by a judge to testify, they are ethically bound not to provide an opinion about a legal matter.
                    Be advised staff will attempt to prevent testimony from occurring. <br /> <br />

                    I consent to services and agree to abide by the above-stated policies and agreements with Heritage Foundation, Inc.</p>


                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Client/Legal Guardian</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>(In a case where a person served is under 18 years of age, a legally responsible adult acting on his/her behalf)</b></p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Witness</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
